/**
 * @return {{click: string}}
 */
export const seeMoreContent = () => ({
  click: 'voir_plus',
});
